import React from "react";
import { Link } from "react-router-dom";
import classNames from "classnames";

/**
 * Drop-in replacement for react-metismenu DefaultLink so sidebar navigation
 * uses React Router (client-side) instead of full document loads.
 */
export default function MetisRouterLink({
  className,
  classNameActive,
  classNameHasActiveChild,
  active,
  hasActiveChild,
  to,
  externalLink,
  hasSubMenu,
  toggleSubMenu,
  activateMe,
  children,
}) {
  const cls = classNames(
    className,
    active && classNameActive,
    hasActiveChild && classNameHasActiveChild
  );

  if (externalLink) {
    return (
      <a
        className={cls}
        href={to || "#"}
        target="_blank"
        rel="noreferrer"
        onClick={activateMe}
      >
        {children}
      </a>
    );
  }

  if (hasSubMenu) {
    return (
      <a
        className={cls}
        href="#"
        onClick={(e) => {
          if (toggleSubMenu) toggleSubMenu(e);
        }}
      >
        {children}
      </a>
    );
  }

  const dest = to && to.length ? to : "/";

  return (
    <Link className={cls} to={dest} onClick={activateMe}>
      {children}
    </Link>
  );
}
